import { ToastOptions } from "@chakra-ui/react";
import { toaster } from "components/ui/toaster";

export class NotificationStore {
  constructor() {}

  show(props: ToastOptions) {
    toaster.create({
      ...props,
    });
  }
}
